import { render, staticRenderFns } from "./TailoringPopUp.vue?vue&type=template&id=5bc0c1fc&scoped=true&"
import script from "./TailoringPopUp.vue?vue&type=script&lang=js&"
export * from "./TailoringPopUp.vue?vue&type=script&lang=js&"
import style0 from "./TailoringPopUp.vue?vue&type=style&index=0&id=5bc0c1fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc0c1fc",
  null
  
)

export default component.exports